import './Footer.css';
import { FaFacebookSquare, FaInstagram } from 'react-icons/fa';
import logo from "../../assets/logo.png"; // Import image

export const Footer = () => {
    const Icon = FaInstagram as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    const IconFb = FaFacebookSquare as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    
    return (
        <>
          <div className="contact-info-container">
      <div className="contact-left">
        <img src={logo} alt="Mind Wonders Logo" className="logo" />
        <p className="tagline">Cultivating Change, Fostering Connection, Empowering You...</p>
      </div>
      <div className="contact-right">
        <p>
          Mind Wonders Psychological Counselling Center, Kurla Camp, Ulhasnagar, Thane – 421004
        </p>
        <a
          href="https://maps.google.com/?q=Mind Wonders Psychological Counselling Center, Kurla Camp, Ulhasnagar"
          target="_blank"
          rel="noopener noreferrer"
          className="direction-button"
        >
          GET DIRECTIONS
        </a>
        <p>+91 – 9699985688</p>
        <p>contact@mindwonderswellness.com</p>
        <div className="social-icons">
          <a href="https://www.facebook.com/people/mindwonderswellness/61558178724224/?mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer">
            <IconFb fontSize={24} color="#E1306C"/>
          </a>
          <a href="https://instagram.com/mindwonders" target="_blank" rel="noopener noreferrer">
            <Icon fontSize={24} color="#E1306C"/>
          </a>
        </div>
      </div>
    </div>
        </>
    );
};